import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "steal",
  "use": "steal-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"steal\"><g fill-rule=\"evenodd\"><path d=\"M5.924 6.452a1.31 1.31 0 01-1.696-.796l2.493-.912a1.328 1.328 0 01-.797 1.708zM0 5.97L1.03 8.53h3.03L.969 15.937h11.314L7.78 2.808 0 5.97zM10.376.813L10.096 0H1.97l1.5 3.156zM9.52 5.049l2.1-.79-.96-2.6-2.07.84zM10.68 8.268l2.12-.79-.84-2.28-2.1.79zM13.14 8.409l-2.11.8 2.44 6.73h2.44z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id